import React, { useState, useEffect } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import * as S from '../../styles';
import {
  BUTTONS,
  DIALOGS,
  mainColumnHeaders,
} from '../../TransportCloudTable.consts';

type Props = {
  open: boolean;
  visibleColumns: Record<string, boolean>;
  onClose: () => void;
  onApply: (newVisibleColumns: Record<string, boolean>) => void;
};

export const ColumnVisibilityDialog = ({
  open,
  visibleColumns,
  onClose,
  onApply,
}: Props) => {
  const [localVisibleColumns, setLocalVisibleColumns] =
    useState<Record<string, boolean>>(visibleColumns);

  useEffect(() => {
    if (open) {
      setLocalVisibleColumns(visibleColumns);
    }
  }, [open, visibleColumns]);

  const handleColumnToggle = (columnKey: string) => {
    setLocalVisibleColumns((prev) => ({
      ...prev,
      [columnKey]: !prev[columnKey],
    }));
  };

  const handleApply = () => {
    onApply(localVisibleColumns);
    onClose();
  };

  const handleCancel = () => {
    setLocalVisibleColumns(visibleColumns);
    onClose();
  };

  const toggleableColumns = Object.entries(mainColumnHeaders);
  const rowsNeeded = Math.ceil(toggleableColumns.length / 4);

  return (
    <S.ColumnVisibilityStyledDialog open={open} onClose={handleCancel}>
      <DialogTitle>{DIALOGS.viewSettingsHeader}</DialogTitle>
      <DialogContent dividers>
        <S.CheckboxContainer $rowsNeeded={rowsNeeded}>
          {toggleableColumns.map(([key, label]) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={localVisibleColumns[key] || false}
                  onChange={() => handleColumnToggle(key)}
                />
              }
              label={label}
            />
          ))}
        </S.CheckboxContainer>
      </DialogContent>
      <DialogActions>
        <S.TCStyledButton $primary onClick={handleApply}>
          {BUTTONS.save}
        </S.TCStyledButton>
        <S.TCStyledButton onClick={handleCancel}>
          {BUTTONS.cancel}
        </S.TCStyledButton>
      </DialogActions>
    </S.ColumnVisibilityStyledDialog>
  );
};
